export default function defineNItemsPlugin(TomSelect) {
  const plugin_n_items = function () {
    const self = this;
    let div;

    const itemCount = function () {
      if (self.items.length == 1) {
        div.innerText = `${self.options[self.items[0]].text}`;
      } else if (self.items.length > 1) {
        div.innerText = `${self.items.length} Selected`;
      } else {
        div.innerText = '';
      }
    };

    self.on("initialize", () => {
      div = document.createElement("div");
      div.className = "ts-n-items";
      self.control.append(div);
      itemCount();
    });

    self.on("item_remove", itemCount);
    self.on("item_add", itemCount);
  };

  return plugin_n_items;
}